import {
  Datagrid,
  NumberField,
  ReferenceManyField,
  SimpleList,
  TextField,
  FunctionField,
  type RaRecord,
} from "react-admin";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { formatINR } from "@/utils";
import { computeProjectTakhmeenPending } from "@/containers/projects/project-takhmeens/project-takhmeen-display";

export const ProjectShowTakhmeenTab = () => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });
  return (
    <ReferenceManyField reference="projectTakhmeens" target="projectId" label={false}>
      {isSmall ? (
        <SimpleList
          primaryText={(record) => String(record.memberName ?? record.itsNo ?? "—")}
          secondaryText={(record) =>
            `ITS ${record.itsNo ?? "—"} · ${formatINR(record.committedAmount, { empty: "—" })} committed`
          }
          tertiaryText={(record) => {
            const pending = formatINR(computeProjectTakhmeenPending(record), { empty: "—" });
            const paid = formatINR(record.paidAmount, { empty: "—" });
            return `Pending ${pending} · Paid ${paid} · ${record.units ?? 0} units`;
          }}
          linkType="show"
          rowSx={() => ({ borderBottom: 1, borderBottomColor: "divider" })}
        />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Datagrid bulkActionButtons={false} rowClick="show" sx={{ minWidth: 720 }}>
            <TextField source="itsNo" label="ITS" />
            <TextField source="memberName" emptyText="—" />
            <NumberField source="units" />
            <NumberField
              source="committedAmount"
              options={{ style: "currency", currency: "INR" }}
            />
            <NumberField source="paidAmount" options={{ style: "currency", currency: "INR" }} />
            <FunctionField
              label="Pending"
              textAlign="right"
              render={(record: RaRecord) =>
                formatINR(computeProjectTakhmeenPending(record), { empty: "—" })
              }
            />
            <FunctionField
              label="Override"
              render={(record: RaRecord) => (record.isAmountOverridden ? "Yes" : "—")}
            />
          </Datagrid>
        </Box>
      )}
    </ReferenceManyField>
  );
};
